const messages = {
    title: "Generate report",
    personal_data: {
        title: "Personal Data",
        email: "Email",
        salutation: "Salutation",
        first_name: "First Name",
        last_name: "Last Name",
        job_position: "Position in Company"
    },
    shipping_address: {
        title: "Shipping Address",
        company: "Company Name",
        street: "Street Number",
        postal_code: "Postal Code",
        mobile_phone: "Mobile Phone",
        iban_number: "IBAN",
        vat: "VAT Number",
        additional_address: "Additional Address",
        city: "City"
    },
    operating_data: {
        title: "Operating Data",
        customer_number: "Customer Number",
        group: "Group",
        customer_group: "Group",
        first_registration: "First Registration",
        last_login: "Last Login",
        tires_per_year: "Tires per Year",
        over_18_inch: "Over 18 Inch",
        premium: "Premium",
        middle: "Middle",
        summer: "Summer",
        winter: "Winter",
        all_season: "All Season",
    },
    calculated_data: {
        title: "Calculated Data",
        tireAmount: "Tire Amount",
        points: "Points",
        bonus: "Bonus"
    },
    sales_structure: {
        title: "Sales Structure",
        sales_representative: {
            title: "Sales Representative",
        },
        distributor: {
            title: "Distributor",
        },
    },
    meta: {
        title: "Meta Data",
        brand: {
            title: "Brand",
            none: ''
        },
        tireType: {
            title: "Tire Type",
            none: ''
        },
        year: {
            title: "Year",
            "2020": "2020",
            "2021": "2021",
            "2022": "2022",
            "2023": "2023",
            "2024": "2024",
            "2025": "2025"
        },
        calendarMonth: {
            title: "Calendar Month",
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December"
        },

    },
    selectAll: "Select All",
    reset: "Reset Filters",
    generate: "Generate Report",
    loadingInfo: 'Generating report, please wait...',
};

export default {
    messages,
};
